import styled from "styled-components";

import { COLORS } from "../../../constants/Styles";

const Container = styled.div`
  text-align: center;
  color: ${COLORS.error};
  margin-top: 1rem;
`;

export { Container };
